import React, {useState, useEffect} from 'react';

type Props = {
    value?: string|null,
    setValue: any,
    title: string,
    largeWidth?: number,
    mediumWidth?: number,
    smallWidth?: number,
    labelStyle?: any,
    inputStyle?: any
}
const Listing = (props: Props) => {
    const [valuesArray, setValuesArray] = useState<string[]>([]);
    const [valuesText, setValuesText] = useState<string>("");
    const [newField, setNewField] = useState<string>("");
    const [initialized, setInitialized] = useState<boolean>(false);
    const [radioStatus, setRadioStatus] = useState<string|null>(null);
    const {value, setValue, title, mediumWidth, largeWidth, smallWidth, inputStyle, labelStyle} = props;

    useEffect(() => {
        if(!initialized){
            if(typeof value === 'string') {
                let result = JSON.parse(value);
                if(typeof result.description === 'string'){
                    setValuesText(result.description);
                    setRadioStatus('text');
                } else {
                    setValuesArray(result.description);
                    setRadioStatus('array');
                }

            }
            setInitialized(true);
        }
    }, []);

    const changeRadio = (event: any) => {
        setRadioStatus(event.currentTarget.value);
    }

    const changeArray = (event: any) => {
        let id = event.target.id;
        let clone = [...valuesArray];
        if(id !== "new"){
            clone[id] = event.target.value;
        } else {
            id = valuesArray.length;
            clone[id] = event.target.value;
        }
        setValuesArray(clone);
        setValue(JSON.stringify({description: clone}));
    }

    const changeNewArrField = (event: any) => {
        setNewField(event.target.value);
    }

    const addArrayItem = (event: any) => {
        let clone = [...valuesArray];
        let id = valuesArray.length;
        clone[id] = newField;
        setNewField("");
        setValuesArray(clone);
        setValue(JSON.stringify({description: clone}));
    }

    const removeArrayItem = (e: any,key: number) => {
        let clone = [...valuesArray];
        if (clone.length === 1){
            clone = [];
        } else {
            clone = clone.splice(key, 1);
        }
        setValuesArray(clone);
        setValue(JSON.stringify({description: clone}));
    }

    const changeText = (event: any) => {
        setValuesText(event.target.value);
        setValue(JSON.stringify({description: event.target.value}));
    }

    return (
        <>
            {initialized && <>
            <div
                className={"list-item-block-offcanvas large-" + largeWidth + " medium-" + mediumWidth + " small-" + smallWidth + " column "}>
                <label className="inb-form__controlLabel" style={labelStyle}>{title}</label>
                <div style={{float:"left",width: "100%", border:"0.2px grey solid", padding: "20px"}}><label htmlFor="id_array" style={{float:"left"}}><input id="id_array" type={"radio"}
                                                          value={"array"} checked={(radioStatus==='array')} onClick={changeRadio}/>Aufzählung</label>
                    <label htmlFor="id_text" style={{float:"left", paddingLeft: "20px"}}><input id="id_text" type={"radio"} value={"text"} checked={(radioStatus==='text')} onClick={changeRadio}/>Freitext</label>
                </div>
                {radioStatus === 'array' && <>
                    <div style={{padding: "10px"}}>&nbsp;</div>
                <div className="inb-form__controllClass" style={{width: "100%"}}>
                {valuesArray.length > 0 &&
                    valuesArray.map((item, i) => ( <><div style={{width: "100%",padding: "10px", display: "flex"}}><input id={i.toString()} type="text" style={{float: "left", width: "100%"}} value={item} key={i} onChange={(e) => changeArray(e)}/>
                            <a href="#" style={{marginLeft: "-20px"}} onClick={e => removeArrayItem(e,i)}>
                                x
                            </a></div></>
                        ))
                    }
                    <div style={{width: "100%",padding: "10px", display: "flex"}}><input type="text" style={{float: "left", width: "100%"}} value={newField} key="new" onChange={e => changeNewArrField(e)}/>
                    <a style={{marginLeft: "-20px"}} href="#" onClick={addArrayItem}>
                        <i className="fi fi-page-add product-icon"></i>
                    </a></div>
                </div>
                </>}
                {radioStatus === 'text' &&<>
                    <div style={{padding: "10px"}}>&nbsp;</div>
                    <div className="inb-form__controllClass" style={{width: "100%"}}>
                        <textarea key={'textss'} onChange={changeText} value={valuesText} aria-multiline={true} rows={3}></textarea>
                    </div>  </>  }
            </div>
            </>}
            </>
            )

            }
            export default Listing;